import Vue from "vue";
import "babel-polyfill";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./main.sass";
import i18n from "./i18n";
import * as VueGoogleMaps from "vue2-google-maps";
import VueSocketIO from "vue-socket.io";
import {
    Swiper as SwiperClass,
    Pagination,
    Mousewheel,
    Autoplay
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.css";

Vue.config.productionTip = false;
Vue.prototype.$reachDishLimitPrice = (data)=>{
    let myOrder = store.state.myOrder;
    let carts = store.state.carts;
    let list = myOrder && store.state.myOrder.items;
    let count = list.filter(it=>it.commodityGuid === data.guid).reduce((pre, cur)=>{
        return pre + Number(cur.quantity);
    }, 0);
    count += carts.filter(it=>it.guid === data.guid).reduce((pre, cur)=>{
        return pre + Number(cur.num);
    }, 0);
    count ++;
    if(!data.commodityPricing || !Number(data.commodityPricing.price_threshold)){
        return false
    }else{
        let limit = Number(data.commodityPricing.price_threshold) - 1;
        if(myOrder.type == 5){
            let personalNum = Number(myOrder.adultNum) + Number(myOrder.childNum);
            limit = personalNum * limit;
        }
        return count > limit;
    }
}
Vue.prototype.$allowAddAttr = (attributesCate, selected, guid, _cateItem)=>{
    let cateItem = null;
    attributesCate.forEach(cate=>{
        if(cate.attributes && cate.attributes.length){
            cate.attributes.forEach(it=>{
                if(it.guid === guid){
                    cateItem = cate;
                }
            })
        }
    });
    if(guid && !cateItem) return false;
    if(!cateItem) cateItem = _cateItem;
    let cateSelectNum = 0;
    attributesCate.forEach(cate=>{
        if(cate.attributes && cate.attributes.length){
            if(cate.guid === cateItem.guid){
                cate.attributes.forEach(it=>{
                    if(selected.includes(it.guid)){
                        cateSelectNum ++;
                    }
                })
            }
        }
    });
    if(Number(cateItem.min_limit) && guid && cateItem.type === 1 && (cateSelectNum >= Number(cateItem.min_limit))){
        alert(cateItem.attr_cate_name + i18n.t("unClass.add390", {num: cateItem.min_limit}));
        return false;
    }
    if(Number(cateItem.min_limit) && !guid && cateItem.type === 0 && (cateSelectNum < Number(cateItem.min_limit))){
        alert(cateItem.attr_cate_name + i18n.t("unClass.add389", {num: cateItem.min_limit}));
        return false;
    }
    if(Number(cateItem.min_limit) && !guid && cateItem.type === 1 && (cateSelectNum !== Number(cateItem.min_limit))){
        alert(cateItem.attr_cate_name + i18n.t("unClass.add392", {num: cateItem.min_limit}));
        return false;
    }
    return true;
}
//自助餐轮数和菜品限制判断
Vue.prototype.$analysisRound = (buffetData, goodsList=[], orderData, isBuffet)=>{
    if(isBuffet!==2) return true;

    let ignoreCategoryGuids = buffetData.categoryGuid && buffetData.categoryGuid || [];

    let existedList = orderData && orderData.items || [];
    let existedNums = existedList.filter(item=>(
        !item.is_people && !ignoreCategoryGuids.includes(item.categoryGuid)
    )).reduce((total, item) => {
        return total + item.quantity;
    }, 0);
    let seq = 0; //这次加菜的轮数
    if(existedNums){
        existedList.forEach(item=>{
            if(item.seq>seq){
                seq = item.seq;
            }
        })
    }

    let addNums = goodsList.filter(item=>(
        !item.is_people && !ignoreCategoryGuids.includes(item.categoryGuid)
    )).reduce((total, item) => {
        return total + (item.num || item.quantity || 1);
    }, 0);

    if(buffetData.is_order_dishes === 1){
        let { adultNum=0, childNum=0 } = orderData,
            { max_per_person_num=0, child_max_per_person_num=0 } = buffetData;
        let totalDish = adultNum * max_per_person_num + child_max_per_person_num *childNum;
        if((addNums + existedNums)>totalDish){
            alert(i18n.t("add.most_add", {num: totalDish}));
            return false;
        }
    }else{
        if(orderData.num_round >= buffetData.how_many_rounds){
            alert(i18n.t("add.most_round", {num: buffetData.how_many_rounds}));
            return false;
        }
        let { adultNum=0, childNum=0 } = orderData;
        let roundMaxNums = (adultNum + childNum) * (buffetData.how_many_dishes || 0);
        if(addNums > roundMaxNums){
            alert(i18n.t("add.most_num_one", {num: buffetData.how_many_dishes}));
            return false;
        }
    }
    return true;
}

SwiperClass.use([Pagination, Mousewheel, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDAOsSG2i2CBqxCVNYGzOkMtlehvUQaobo",
        libraries: "places",
        region: "ES",
        language: "es"
        // v: "3.26"
    }
    // Demonstrating how we can customize the name of the components
    // installComponents: false
});

Vue.use(
    new VueSocketIO({
        debug: true,
        // process.env.VUE_APP_API_BASE_URL
        connection: process.env.VUE_APP_SOCKET_URL,
        vuex: {
            store,
            actionPrefix: "SOCKET_",
            mutationPrefix: "SOCKET_"
        },
        options: {path: ""} //Optional options
    })
);

export default new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
